import { h } from 'preact';

const Copy = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path d="M13 3h-2V2a1 1 0 00-1-1H3a1 1 0 00-1 1v10a1 1 0 001 1h2v1a1 1 0 001 1h7a1 1 0 001-1V4a1 1 0 00-1-1zM3 12V2h7v1H6a1 1 0 00-1 1v8H3zm10 2H6V4h7v10z" />
		</svg>
	);
};

export default Copy;
